// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing110({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <RandingStyle10
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/110/250306_01.gif`}
        videoPath={`${process.env.REACT_APP_CDN_BASE}/images/110/250306_02.mp4`}
        qOptionColor="blue"
        formFieldColor="white"
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      />
    </>
  );
}

export default Randing110;
